<template>
  <div>
    <DeleteModal modalId="modal-radiology-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-radiology-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('radiology.Add Patient Card Radiology')
          : $t('radiology.Edit Patient Card Radiology')
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <AutoComplete
              :label="$t('radiology.radiology')"
              :placeholder="$t('radiology.radiology')"
              v-model="EditForm.radiology_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="radiology"
              text-title="name"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.type')">
              <v-select
                v-model="EditForm.type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="typeList"
                label="text"
                :reduce="(type) => type.value"
                :placeholder="$t('common.type')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("radiology.Patient Card Radiology") }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="
              $store.state.app.permissions.includes(
                'store-patientCardRadiology'
              ) && !isHistory
            "
            :disabled="disabled"
          >
            {{ $t("radiology.Add Patient Card Radiology") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(type)="data">
            <div class="text-nowrap">
              {{ data.item.type == 0 ? "Sonar" : "CXR" }}
              <!-- Dropdown -->
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                v-if="!isHistory"
                deletePerm="update-patientCardRadiology"
                editPerm="update-patientCardRadiology"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
                :disabled="disabled"
              />
              <!-- Dropdown -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientsRadiologies()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    vSelect,
  },
  props: ["patientCardId", "isHistory", "disabled"],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      patientCard: "",
      typeList: [
        {
          text: "sonar",
          value: "0",
        },
        {
          text: "CXR",
          value: "1",
        },
      ],
      dataCount: 0,
      data: [],
      EditForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "type", sortable: true, label: this.$t("common.type") },
        { key: "url", sortable: true, label: this.$t("common.url") },
        { key: "actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getPatientsRadiologies();
  },

  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          type: "",
          url: "",
          patient_card_id: this.patientCardId,
          radiology_id: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        console.log(this.EditForm);
        this.EditForm.id = item.id;
        this.EditForm.url = item.url;
        this.EditForm.patient_card_id = this.patientCardId;
        this.EditForm.radiology_id = item.radiology_id;
        this.EditForm.type = item.type.toString();

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-radiology-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getPatientsRadiologies() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patientCardRadiology?filter[patient_card_id]=${this.patientCardId}&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.patientCard) {
        url += `&filter[patient_card_id]=${this.patientCard}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-radiology-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/patientCardRadiology/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientsRadiologies();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardRadiology`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Patient Card Radiology Added",
                  variant: "success",
                },
              });
              this.getPatientsRadiologies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardRadiology/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientsRadiologies(this.patientCard);
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
